module.exports = __webpack_public_path__ + "static/media/model_big.fa68399b.png";